/* global globalThis */
import { useEffect } from "react";
import axiosClient from "../../api-client/AxiosClient";
const application_id = process.env.REACT_APP_APPLICATION_ID;

export const getUserSelectedOrgConfig = async () => {
    try {
        const response = await axiosClient.get(
            "/api/Organization/GetUserSelectedOrgConfig"
        );
        return response?.data ?? null;
    } catch (error) {
        console.error("Failed to get user selected org config:", error);
        return null;
    }
};

export const setUserSelectedOrgConfig = async () => {
    try {
        const organizationConfigId = localStorage.getItem("organization_config_id");
        const selectedCorporation = localStorage.getItem("selectedCorporation");
        const UserMappingFileId = localStorage.getItem("UserMappingFileId");
        const organizationId = selectedCorporation
            ? JSON.parse(selectedCorporation)?.value?.toString()
            : null;

        if (!organizationConfigId || !organizationId) {
            return null;
        }

        const payload = {
            organizationConfigId: String(organizationConfigId),
            organizationId: String(organizationId),
            userMappingFileId: String(UserMappingFileId),
        };

        const response = await axiosClient.post(
            "/api/Organization/SetUserSelectedOrgConfig",
            payload
        );

        return response?.data ?? null;
    } catch (error) {
        console.error("Failed to set user selected org config:", error);
        return null;
    }
};



// Helper functions for merging roles and permissions
const mergeModulePermissions = (merged, module, permissions) => {
    if (merged[module]) {
        Object.keys(permissions).forEach((key) => {
            merged[module][key] = merged[module][key] || permissions[key];
        });
    } else {
        merged[module] = { ...permissions };
    }
};

const processRole = (merged, role) => {
    Object.entries(role).forEach(([module, permissions]) => {
        mergeModulePermissions(merged, module, permissions);
    });
};

const mergeRolesAndPermissions = (rolesData) => {
    const merged = {};
    Object.values(rolesData).forEach((role) => {
        processRole(merged, role);
    });
    return merged;
};

export const fetchPermissions = async (configId) => {
    try {
        if (!configId) return null;

        const response = await axiosClient.get(`/api/User/Permissions?OrgConfigId=${configId}&ApplicationId=${application_id}`);

        if (response?.data) {
            const merged = mergeRolesAndPermissions(response.data);
            sessionStorage.setItem("rolesAndPermission", JSON.stringify(merged));

            // Dispatch event to notify listeners (like layout.js) that permissions are loaded
            globalThis.dispatchEvent(new CustomEvent("permissionsUpdated", { detail: merged }));
            return merged;
        }
        return null;
    } catch (error) {
        console.error("Failed to fetch permissions:", error);
        // Even on error, dispatch event to prevent infinite loading state
        globalThis.dispatchEvent(new CustomEvent("permissionsUpdated", { detail: null }));
        return null;
    }
};

export const useOrgConfigSync = () => {
    useEffect(() => {
        // Initial check on mount to ensure layout.js unblocks
        const storedRoles = sessionStorage.getItem("rolesAndPermission");
        const configId = localStorage.getItem("organization_config_id");

        if (!storedRoles && configId) {
            fetchPermissions(configId).then(() => {
                setUserSelectedOrgConfig();
            });
        }

        const handleStorageChange = async (e) => {
            if (
                e.detail?.key === "organization_config_id" ||
                e.detail?.key === "selectedCorporation"
            ) {
                await setUserSelectedOrgConfig();

                // Fetch permissions if config changed
                if (e.detail?.key === "organization_config_id" && e.detail?.newValue) {
                    await fetchPermissions(e.detail.newValue);
                }
            }
        };

        globalThis.addEventListener("customStorageChange", handleStorageChange);
        return () => {
            globalThis.removeEventListener("customStorageChange", handleStorageChange);
        };
    }, []);
};